var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.163 0 0 6.96 0 15.544C0 24.129 7.163 31.088 16 31.088C24.837 31.088 32 24.129 32 15.544C32 6.959 24.837 0 16 0ZM22.668 10.2C23.0294 10.2968 23.3591 10.4869 23.6239 10.7512C23.8888 11.0155 24.0795 11.3448 24.177 11.706C24.533 13.033 24.533 15.803 24.533 15.803C24.533 15.803 24.533 18.573 24.177 19.901C24.0793 20.2622 23.8883 20.5913 23.6233 20.8555C23.3583 21.1196 23.0285 21.3095 22.667 21.406C21.337 21.762 16 21.762 16 21.762C16 21.762 10.663 21.762 9.332 21.406C8.97068 21.3093 8.64111 21.1194 8.37628 20.8553C8.11145 20.5911 7.92065 20.2621 7.823 19.901C7.467 18.573 7.467 15.803 7.467 15.803C7.467 15.803 7.467 13.033 7.823 11.706C7.92059 11.3446 8.11147 11.0153 8.37649 10.751C8.64152 10.4866 8.97138 10.2966 9.333 10.2C10.662 9.845 16 9.845 16 9.845C16 9.845 21.337 9.845 22.668 10.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 18.6529V13.4719L18.667 16.0619L14.4 18.6529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d9fbaba4e095ebf0f13f79bb70f2768f.svg";
export { ForwardRef as ReactComponent };